import { useContext, useEffect } from 'react';
import StatusCard from '@/home/OrderStatusCard';
import OrderState from '~/constants/home/orderState';
import { useIsLoggedIn } from '~/context/common/UserContext';
import GlobalContext from '~/context/home/GlobalContext';
import { useGetUserPurchase } from '~/context/home/UserPurchaseContext';
import { FinanceCard, TradeCard } from './Cards';
import {
  FinanceTradeWrapper,
  GridWrapper,
  HeroFavoriteAndSearchCard
} from './HeroCardsReturnUser.styles';
import { SRPLinks, VDPLinks } from './LinkCards';

export default function HeroCardsReturnUser() {
  const {
    isLoaded,
    data: { orderState }
  } = useGetUserPurchase();
  const { setIsVdpLinksLoaded } = useContext(GlobalContext);
  const isLoggedIn = useIsLoggedIn();
  const shouldShowPurchaseCard =
    isLoggedIn && (!isLoaded || orderState !== OrderState.None);

  /*
   * need to set isVdpLinksLoaded when shouldShowPurchaseCard is true
   * since the VdpLink will not be rendered
   */
  useEffect(() => {
    if (shouldShowPurchaseCard) {
      setIsVdpLinksLoaded(true);
    }
  }, [setIsVdpLinksLoaded, shouldShowPurchaseCard]);

  const negativeTopMargin = isLoggedIn
    ? 'mt-[-35px]'
    : 'mt-[-65px] m:mt-[-35px]';

  //Large break point moved to 1200px so that text is not wrapped and truncated as much
  return (
    <div className="flex w-full justify-center bg-white">
      <div className="flex w-full flex-col gap-40 px-24 m:max-w-[1056px] l:max-w-[1272px] xl:px-0">
        {shouldShowPurchaseCard && <StatusCard />}

        <GridWrapper
          showPurchase={shouldShowPurchaseCard}
          negativeTopMargin={negativeTopMargin}
          data-qa="link-card-container"
        >
          <HeroFavoriteAndSearchCard>
            <VDPLinks />
          </HeroFavoriteAndSearchCard>
          <HeroFavoriteAndSearchCard>
            <SRPLinks />
          </HeroFavoriteAndSearchCard>

          <FinanceTradeWrapper showPurchase={shouldShowPurchaseCard}>
            <FinanceCard />
            <TradeCard />
          </FinanceTradeWrapper>
        </GridWrapper>
      </div>
    </div>
  );
}
